function sanitizeCsvFileName(fileName) {
    const normalizedName = String(fileName || "export")
        .trim()
        .replace(/[<>:"/\\|?*\x00-\x1f]/g, "-")
        .replace(/\s+/g, " ")
        .replace(/^\.+|\.+$/g, "")
    return normalizedName || "export"
}

function downloadCSV(dataArray, fileName, headers = null) {
    const csvContent = convertArrayOfObjectsToCSV(dataArray, headers)
    const link = document.createElement("a")
    const safeFileName = `${sanitizeCsvFileName(fileName)}.csv`

    link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(`\ufeff${csvContent}`)}`
    link.download = safeFileName
    link.rel = "noopener"
    link.style.display = "none"
    document.body.appendChild(link)
    link.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }))
    document.body.removeChild(link)
}

function convertArrayOfObjectsToCSV(dataArray, headers = null) {
    if (!dataArray || !dataArray.length) {
        return ""
    }
    const columns = headers && headers.length ? headers : Object.keys(dataArray[0])
    const escapeCsvValue = (value) => {
        const normalizedValue = value === null || value === undefined ? "" : `${value}`
        if (/[",\n\r]/.test(normalizedValue)) {
            return `"${normalizedValue.replace(/"/g, '""')}"`
        }
        return normalizedValue
    }
    const header = columns.map(escapeCsvValue).join(",")
    const rows = dataArray
        .map((obj) =>
            columns
                .map((column) => obj[column])
                .map(escapeCsvValue)
                .join(",")
        )
    return [header, ...rows].join("\r\n")
}

export { downloadCSV, convertArrayOfObjectsToCSV }
